export const linkedinConnectionTypes = {
  company: 'company',
  profile: 'profile'
} as const;

export type LinkedinConnectionType = keyof typeof linkedinConnectionTypes;
